import countryData from '@material-dev/country-data';
import sortBy from 'lodash/sortBy';

const countrySort = (countries, primaryCountry) => prioritizeCountriesList(
  createCountryCodeList(
    sortCountriesByName(
      addCountryNames(countries)
    )
  ),
  primaryCountry
);

const addCountryNames = countries => countries.map(country => ({
  ...country, name: countryData.countries[country.country].name
}));

const createCountryCodeList = countries => countries.map((country) => {
  return country.country;
});

const sortCountriesByName = countries => sortBy(countries, country => country.name);

const prioritizeCountriesList = (countries, primaryCountry) => {
  if (countries.find(item => item === primaryCountry)) return sortByPrimaryCountry(countries, primaryCountry);
  return countries;
};

const sortByPrimaryCountry = (list, primary) => list.filter(item => item === primary)
  .concat(list.filter(item => item !== primary));

export default countrySort;



// WEBPACK FOOTER //
// ./src/app/admin/services/utils/countrySort.js